module.exports = __webpack_public_path__ + "static/media/home-onepage-box-image-03.1797586d.gif";